import axios from "axios";
import SearchBar from "components/SearchBar/SearchBar";
import SearchBarProduct from "components/SearchBar/SearchBarProduct";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

// components

export default function AddProduct({ showModal, setShowModal, setItems, items, units }) {
    const [result, setResult] = useState("");
    const [products, setProducts] = useState("");
    const [pending, setPending] = useState(true);
    const [totalRows, setTotalRows] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [datasSearch, setDatasSearch] = useState("");
    const [datas, setDatas] = useState("");
    const handelProduct = (e) => {

        const exist = items.find(x => x.productCode === e.productCode)
        if (exist) {
            Swal.fire({
                icon: 'error',
                text: 'มีสินค้านี้อยู่แล้ว',
            })
            return
        }
        setItems(item => [...item, {
            productCode: e.productCode,
            productName: e.productName,
            qty: 1,
            quantityWH: e.qty,
            unit: e.unit,
            pricePerUnit: e.pricePerUnit,
            discountPerUnit: 0,
            no: items.length + 1
        }])
        setShowModal(false)
    }
    // console.log(items);
    useEffect(() => {
        axios.get(`http://${process.env.REACT_APP_API_URL}/products/search-All`, {
            headers: {
                Bearer: localStorage.getItem('token')
            }
        }).then((response) => {
            if (response.status === 200) {
                setProducts(response.data);
                setResult(response.data)
                setPending(false);
            }
        }
        ).catch((error) => {
            if (error.response.data.status === 401) {
                window.location.href = "/auth/login";
            }
            console.log(error);
        });


    }, [])


    const columns = [
        {
            name: 'รูปภาพสินค้า',
            selector: row => <img src={`data:image/jpeg;base64,${row.product.image}`} alt={row.product.productName} width="400" height="400" />
        },
        {
            name: "รหัสสินค้า",
            selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.product.productCode}</div>,
            sortable: true,
        },
        {
            name: "ชื่อสินค้า",
            selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.product.productName}</div>,
            sortable: true,
        },
        {
            name: "จำนวน",
            selector: row => row.product.qty,
            sortable: true,
        },
        {
            name: "ราคาต่อหน่วย",
            selector: row => row.product.pricePerUnit,
            sortable: true,
        },
        {
            name: 'Add',
            button: true,
            cell: (row) => row.product.qty !== 0 && <button onClick={() => handelProduct(row)} ><i className="mr-2 text-sm rounded-lg fas fa-plus " style={{ width: "50px", background: "#83A3FF" }} /></button>,
        },

    ];
    const columns2 = [
        {
            name: 'รูปภาพสินค้า',
            selector: row => <img src={`data:image/jpeg;base64,${row.image}`} alt={row.productName} width="400" height="400" />
        },
        {
            name: "รหัสสินค้า",
            selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.productCode}</div>,
            sortable: true,
        },
        {
            name: "ชื่อสินค้า",
            selector: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.productName}</div>,
            sortable: true,
        },
        {
            name: "จำนวน",
            selector: row => row.qty,
            sortable: true,
        },
        {
            name: "ราคาต่อหน่วย",
            selector: row => row.pricePerUnit,
            sortable: true,
        },
        {
            name: 'Add',
            button: true,
            cell: (row) => row.qty !== 0 && <button onClick={() => handelProduct(row)} ><i className="mr-2 text-sm rounded-lg fas fa-plus " style={{ width: "50px", background: "#83A3FF" }} /></button>,
        },

    ];

    const customStyles = {
        table: {
            style: {
                borderRadius: "20px",
            },
        },
        rows: {
            style: {
                minHeight: '72px',
                // override the row height
                '&:hover': {
                    // cursor: 'pointer',
                    backgroundColor: "#B4BDFF",

                },
            },
        },
        expanderCell: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: "#83A2FF",

            },
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: "#83A2FF",

            },
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px',

            },

        },

    };

    const fetchOrders = async pageNum => {
        setPending(true);

        axios.post(`http://${process.env.REACT_APP_API_URL}/products/search-all-pagination`, { page: pageNum, pageSize: perPage }, {
            headers: {
                bearer: localStorage.getItem('token')
            }
        }).then((response) => {
            if (response.status === 200) {
                setDatas(response.data.productHis);
                setResult(response.data.productHis);
                setTotalRows(response.data.count);
                setPending(false);
            }
        }
        ).catch((error) => {
            if (error.response.data.status === 401) {
                window.location.href = "/auth/login";
            }
            console.log(error.response.data.message);
        });

        // axios.get(`http://${process.env.REACT_APP_API_URL}/products/count`, {
        //   headers: {
        //     Bearer: localStorage.getItem('token')
        //   }
        // }).then((response) => {
        //   if (response.status === 200) {
        //     setTotalRows(response.data.totals);
        //   }
        // }
        // ).catch((error) => {
        //   if (error.response.data.status === 401) {
        //     window.location.href = "/auth/login";
        //   }
        //   console.log(error);
        // });
    };

    const handlePageChange = page => {
        fetchOrders(page);
    };

    const handlePerRowsChange = async (newPerPage, pageNum) => {
        setPending(true);
        // console.log(newPerPage,pageNum);
        axios.post(`http://${process.env.REACT_APP_API_URL}/products/search-all-pagination`, { page: pageNum, pageSize: newPerPage }, {
            headers: {
                bearer: localStorage.getItem('token')
            }
        }).then((response) => {
            // console.log(response);
            if (response.status === 200) {
                setDatas(response.data.productHis);
                setResult(response.data.productHis);
                setPerPage(newPerPage);
                setPending(false);
            }
        }
        ).catch((error) => {
            if (error.response.data.status === 401) {
                window.location.href = "/auth/login";
            }
            console.log(error.response.data.message);
        });
    };

    // useEffect(() => {
    //     fetchOrders(1); // fetch page 1 of users

    // }, []);

    return (
        <>
            {showModal && <>
                <div
                    className="absolute inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none addproduct focus:outline-none"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", minHeight: "1200px" }}
                // className="fixed inset-0 flex items-center justify-center w-full h-full overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
                // onClick={() => setShowModal(false)}
                >
                    <div className="relative mx-auto my-6 " >
                        {/*content*/}
                        <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                            {/*header*/}
                            <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                                <h3 className="text-3xl font-semibold">
                                    เพิ่มสินค้า
                                </h3>

                                <SearchBar data={products} setResult={setResult} />
                                {/* <SearchBarProduct data={datas} setResult={setResult} setPending={setPending} setTotalRows={setTotalRows} setPerPage={setPerPage} setDatasSearch={setDatasSearch} /> */}
                                <button
                                    className="float-right p-1 text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span className="block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none">
                                        ×
                                    </span>
                                </button>
                            </div>
                            {/*body*/}
                            <div className="relative flex-auto p-6">
                                <div className="grid mb-6 -mx-3">
                                    <div className="grid p-5">
                                        {/* {!datasSearch ? <DataTable
                                            data={result}
                                            columns={columns}
                                            customStyles={customStyles}
                                            pagination
                                            progressPending={pending}
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onChangePage={handlePageChange}
                                        >
                                        </DataTable>
                                            : */}
                                            <DataTable
                                                data={result && result.filter(item => item.qty !== 0)}
                                                columns={columns2}
                                                pagination
                                                customStyles={customStyles}
                                                progressPending={pending}
                                            >
                                            </DataTable>
                                            {/* } */}

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>}
        </>
    );
}
